<template>
  <div class="invite_suc">
    <van-nav-bar title left-arrow @click-left="back" />
    <div class="wrap">
      <div v-if="updateLoading" style="margin-bottom: 0.22rem">
        <van-loading color="#1989fa" />
      </div>
      <svg-icon v-else icon-class="suc" />
      <p>{{ updateLoading ? '提交中' : '邀约成功' }}</p>
      <div class="tip">
        <span>温馨提示：</span>
        <p>1、您可点击下方按钮分享微信邀请函给访客，或复制邀请函链接发送短信给访客；</p>
        <p>2、作为访客的安全联系人，请提醒该访客来访期间注意安全，遵守大厦规则。</p>
      </div>
      <div class="btns">
        <van-button type="primary" size="large" :disabled="updateLoading" @click="onShare">分享邀请函</van-button>
        <van-button class="link" type="info" size="large" :disabled="updateLoading" style="margin-top: 0.2rem" @click="onCopy">复制邀请函链接</van-button>
      </div>
    </div>
    <div v-if="showTips" class="cover">
      <svg-icon icon-class="share" class-name="share" />
      <svg-icon icon-class="share_btn" class-name="shareBtn" @click="showTips = false" />
    </div>
  </div>
</template>
<script>
import { inviteShare } from '@/api/user';
import Clipboard from 'clipboard';
import wx from 'weixin-js-sdk';
import { wechatSignature } from '@/api/home';

export default {
  name: 'InviteSuc',
  data() {
    return {
      updateLoading: false,
      showTips: false,
      inviteUrl: '',
      shareInfo: {}
    };
  },
  mounted() {
    this.updateLoading = true;
    this.timer = window.setInterval(() => {
      setTimeout(() => {
        this.getShare();
      }, 0);
    }, 1000);
  },
  destroyed() {
    if (this.timer) {
      window.clearInterval(this.timer);
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getShare() {
      // 10023325
      inviteShare({ id: this.$route.query.id }).then(res => {
        if (res.data.done) {
          window.clearInterval(this.timer);
          this.inviteUrl = res.data.url;
          this.updateLoading = false;
          this.shareInfo = res.data;
        }
      }).catch(_ => {
        window.clearInterval(this.timer);
        setTimeout(() => {
          this.$router.push({ name: 'staffHistoryDetail', query: { id: this.$route.query.id, activeName: 'inviteReord' }});
          this.updateLoading = false;
        }, 2000);
      });
    },
    onShare() {
      this.showTips = true;
      const url = window.location.href.split('#');
      wechatSignature({ url: url[0] }).then(res => {
        // 要显示的菜单项，所有menu项见附录3
        // wx.config({
        //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //   appId: res.data.appId, // 必填，公众号的唯一标识
        //   timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        //   signature: res.data.signature, // 必填，签名
        //   jsApiList: ['updateAppMessageShareData', 'showMenuItems'] // 必填，需要使用的JS接口列表
        // });
        wx.showMenuItems({
          menuList: ['menuItem:share:appMessage'] // 要显示的菜单项，所有menu项见附录3
        });
        wx.updateAppMessageShareData({
          title: this.shareInfo.title, // 分享标题
          desc: this.shareInfo.desc, // 分享描述
          link: this.shareInfo.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.shareInfo.image, // 分享图标
          success: function() {
            // 设置成功
          }
        });
      });
    },
    onCopy() {
      const that = this;
      const clipboard = new Clipboard('.link', {
        text: function() {
          return that.inviteUrl;
        }
      });
      clipboard.on('success', e => {
        this.$toast({
          message: '复制成功'
        });
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        this.$toast({
          message: '复制失败'
        });
        clipboard.destroy();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.invite_suc {
  min-height: 100vh;
  position: relative;
  .svg-icon {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }
  .wrap {
    text-align: center;
    margin-top: 0.7rem;
    font-size: 0.14rem;
    color: #333;
    > p {
      font-size: 0.2rem;
    }
    .tip {
      text-align: left;
      margin-top: 0.2rem;
      padding: 0 0.27rem;
      line-height: 0.28rem;
      span {
        color: #f2b230;
        line-height: 0.3rem;
      }
      p {
        color: #888;
      }
    }
    .btns {
      margin-top: 0.3rem;
      padding: 0rem 0.28rem;
      //> div {
      //  font-size: 0.18rem;
      //  color: #fff;
      //  border-radius: 5px;
      //  line-height: 0.47rem;
      //  text-align: center;
      //  margin-bottom: 0.2rem;
      //}
      //div:first-child {
      //  background: #3b86ff;
      //  border: 2px solid rgba(5, 5, 5, 0.0823);
      //}
      //div:last-child {
      //  background: rgba(45, 204, 44, 1);
      //  border: 2px solid rgba(5, 5, 5, 0.0823);
      //}
    }
  }

  .cover {
    position: absolute;
    opacity: 0.5;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: black;
    z-index: 9999;
    .share {
      position: absolute;
      right: 20px;
      top: 10px;
      width: 2rem;
      height: 2rem;
    }
    .shareBtn {
      position: absolute;
      right: 0;
      top: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>
